import { createContext, useContext } from 'react';

import { DispositiveProvisionsSuggestedRecipientsQuery } from '@/modules/aiSuggestions/AISuggestionsMatcher/graphql/SuggestedRecipients.generated';

// An undefined context means there is no form-level owner. A mounted provider
// still supplies an object while loading, so consumers do not fetch separately.
export const RecipientDataContext = createContext<
  | { data: DispositiveProvisionsSuggestedRecipientsQuery | undefined }
  | undefined
>(undefined);

export const useRecipientData = () => useContext(RecipientDataContext);
